import UserImageData, { useUserImageDataURL } from "../../data/user-image-data";
import {
	MapHelperInstance,
	useStyleDependantMapEffect,
	useStyleSetupMapEffect,
} from "../../helper/map-helper";
import { ImageSource } from "mapbox-gl";
import { imageSourceBlank } from "./mapbox-injectable";
import { FloorplanImage } from "../../data/floorplan-image";

export interface MapboxInjectableFloorplanImageParams {
	mapInstance: MapHelperInstance;
	image?: FloorplanImage | null;
}

const mapboxIDFloorplanImage = "floorplan-image";

export default function useMapboxInjectableFloorplanImage(
	params: MapboxInjectableFloorplanImageParams,
) {
	const floorImageURL = useUserImageDataURL(params.image?.data.renderable);

	const floorImageCoords = params.image?.coords;

	useStyleSetupMapEffect(params.mapInstance, (_, box) => {
		box.addSource(mapboxIDFloorplanImage, {
			type: "image",
			...imageSourceBlank,
		});
		box.addLayer({
			id: mapboxIDFloorplanImage,
			source: mapboxIDFloorplanImage,
			type: "raster",
			paint: {
				"raster-opacity": 0.4,
				"raster-fade-duration": 0,
			},
		});
	});

	useStyleDependantMapEffect(
		params.mapInstance,
		(map) => {
			//Update the floor plan image
			const floorplanImageSource = map.getSource(
				mapboxIDFloorplanImage,
			) as ImageSource;

			if (floorImageURL !== undefined && floorImageCoords !== undefined) {
				floorplanImageSource.updateImage({
					url: floorImageURL,
					coordinates: floorImageCoords,
				});
			} else {
				floorplanImageSource.updateImage(imageSourceBlank);
			}
		},
		[floorImageURL, floorImageCoords],
	);

	useStyleDependantMapEffect(
		params.mapInstance,
		(map) => {
			//Update the opacity
			map.setPaintProperty(
				mapboxIDFloorplanImage,
				"raster-opacity",
				params.image?.opacity ?? 0.4,
			);
		},
		[params.image?.opacity],
	);
}
